export const SALES_RETURN_RATE = 0;
